import api from './api';

export interface TranscriptData {
  id: string;
  title: string;
  video_id?: string;
  text?: string; // Full transcript as string
  tracks?: Array<{
    language: string;
    transcript: Array<{
      text: string;
      start: number;
      dur: number;
    }>;
  }>;
  transcript?: Array<{
    text: string;
    start: number;
    duration?: number;
    dur?: number;
  }> | string;
}

export interface TranscriptResponse {
  success: boolean;
  data: TranscriptData | null;
  video_id: string;
}

export interface TranscriptToken {
  id: number;
  token: string;
  is_active: boolean;
  last_used_at: string | null;
  usage_count: number;
  created_at: string | null;
  updated_at: string | null;
}

export const transcriptService = {
  getTranscript: async (url: string): Promise<TranscriptResponse> => {
    const response = await api.post<TranscriptResponse>('/transcript', {
      url,
    });
    return response.data;
  },

  // Admin functions
  getTokens: async (): Promise<TranscriptToken[]> => {
    const response = await api.get<{ success: boolean; tokens: TranscriptToken[] }>(
      '/admin/transcript-tokens'
    );
    return response.data.tokens;
  },

  getToken: async (tokenId: number): Promise<TranscriptToken> => {
    const response = await api.get<{ success: boolean; token: TranscriptToken }>(
      `/admin/transcript-tokens/${tokenId}`
    );
    return response.data.token;
  },

  createToken: async (token: string, isActive: boolean = true): Promise<TranscriptToken> => {
    const response = await api.post<{ success: boolean; token: TranscriptToken }>(
      '/admin/transcript-tokens',
      {
        token,
        is_active: isActive,
      }
    );
    return response.data.token;
  },

  updateToken: async (
    tokenId: number,
    updates: { token?: string; is_active?: boolean }
  ): Promise<TranscriptToken> => {
    const response = await api.put<{ success: boolean; token: TranscriptToken }>(
      `/admin/transcript-tokens/${tokenId}`,
      updates
    );
    return response.data.token;
  },

  deleteToken: async (tokenId: number): Promise<void> => {
    await api.delete(`/admin/transcript-tokens/${tokenId}`);
  },
};

